/* eslint-disable max-lines */ //TODO refactor max lines and complexity
/* eslint-disable complexity */
import { inject, Injectable } from '@angular/core';
import { EVENT_CLICK_TYPE, HEADER_MENU } from '../../../../constants/utils';
import { ClickEventAnalytics } from '../../../../models/utils';
import {
  AnalyticsBaseClick,
  AnalyticsBaseDetailsClick,
  HomepageAnalyticsService
} from '../../../../models/utils/analytics-extended.interfaces';
import { CountryLanguageHelper } from '../../../../utils/country-language/country-language-helper';
import {
  buildClickPayload,
  findComponentAction,
  isAttributeOrButton,
  resolveEventAndAction
} from './analytics-click.utils';
import { AnalyticsDataPopulateSupportService } from './analytics-data-populate-support.service';

@Injectable({ providedIn: 'root' })
export class AnalyticsDataPopulateHelperSupportService extends AnalyticsDataPopulateSupportService {
  private countryLanguageHelper = inject(CountryLanguageHelper);

  private getEventDetail(
    elementRef: HTMLElement,
    defaultEventDetail: string
  ): string {
    return (
      elementRef.getAttribute('data-acdl-event-detail') || defaultEventDetail
    );
  }

  getDefaultButtonDetails(
    elementRef: HTMLElement,
    actionDetail: string,
    pageSection: string
  ): AnalyticsBaseDetailsClick {
    const label = this.getLabel(elementRef);
    const isBookingTab = elementRef.getAttribute('data-booking-tab') === 'true';
    const action = isBookingTab ? actionDetail : `${actionDetail} cta click`;
    const eventDetail = isBookingTab
      ? actionDetail
      : `${actionDetail}:cta click`;
    return {
      label,
      eventDetail: this.getEventDetail(elementRef, eventDetail),
      pageSection,
      action
    };
  }

  getLabel(elementRef: HTMLElement): string {
    return (
      this.getDataAttribute(elementRef, 'data-acdl-name') ||
      elementRef.textContent?.replace(/\s+/g, ' ').trim() ||
      ''
    );
  }

  getComponentBasedDetails(
    elementRef: HTMLElement,
    pageSection: string,
    pageAttribute?: string
  ): AnalyticsBaseDetailsClick {
    const finalPageSection = pageAttribute
      ? `${pageAttribute}:${pageSection}`
      : pageSection;
    return {
      label: elementRef.textContent?.replace(/\s+/g, ' ').trim() || '',
      eventDetail: `${pageSection} click`,
      pageSection: finalPageSection,
      action: this.getComponentAction(elementRef)
    };
  }

  getComponentAction(elementRef: HTMLElement): string {
    return findComponentAction(elementRef, (el) => this.getElementAction(el));
  }

  handleBaseAnalytics(base: AnalyticsBaseClick): ClickEventAnalytics {
    const [eventDetail, action] = resolveEventAndAction(base);
    return {
      ...this.createBaseAnalytics(
        base.eventType,
        eventDetail,
        base.includeProfile,
        base.pageAttribute,
        base.elementRef
      ),
      click: buildClickPayload(base, action)
    };
  }

  checkAttributeORButton(baseAnalytics: AnalyticsBaseClick): boolean {
    return isAttributeOrButton(baseAnalytics);
  }

  createCheckboxAnalytics(
    elementRef: HTMLElement,
    eventType: string,
    action: string,
    pageSection: string
  ): ClickEventAnalytics | null {
    const checkbox = elementRef as HTMLInputElement;
    if (!checkbox.checked) return null;
    const label = this.getCheckboxLabel(elementRef);
    return {
      ...this.createBaseAnalytics(
        eventType,
        'flight search widget:filter select',
        true
      ),
      click: {
        name: label,
        type: EVENT_CLICK_TYPE.CHECKBOX,
        page_section: pageSection,
        action: `${action} ${label} checkbox click`
      }
    };
  }

  trackPageLoad(
    elementRef: HTMLElement,
    analytics: HomepageAnalyticsService
  ): void {
    const siteAssets = analytics.collectSiteAssets(elementRef);
    const countryCode =
      this.countryLanguageHelper.getCountryCodeFromPrefCookie() || 'us';
    const languageCode =
      this.countryLanguageHelper.getLanguageCodeFromPrefCookie() || 'en';
    analytics.trackPageLoad(
      {
        page_name: HEADER_MENU.HOMEPAGE.PAGE_NAME,
        page_type: HEADER_MENU.HOMEPAGE.PAGE_TYPE,
        section: HEADER_MENU.HOMEPAGE.SECTION,
        country: countryCode.toLowerCase(),
        language: languageCode.toLowerCase(),
        legacy_page_name: HEADER_MENU.HOMEPAGE.LEGACY_PAGE_NAME
      },
      siteAssets
    );
  }
}
